var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParents({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "Parents.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Parents",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(23.9594,62.6185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -0.026 c -4.113,-0.015 -7.452,-3.332 -7.441,-7.395 0.011,-4.15 3.248,-7.397 7.372,-7.397 h 0.013 v 0 c 4.19,0.007 7.356,3.198 7.363,7.423 C 7.284,-5.418 6.504,-3.565 5.086,-2.15 3.697,-0.763 1.891,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(68.7572,76.8185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -2.32,2.316 -5.336,3.59 -8.494,3.59 h -0.043 c -6.87,-0.025 -12.445,-5.565 -12.427,-12.35 0.018,-6.93 5.424,-12.352 12.311,-12.352 h 0.021 10e-4 c 6.998,0.011 12.284,5.34 12.295,12.395 C 3.669,-5.459 2.368,-2.363 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(82.586,29.3341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.458,-0.074 -0.921,-0.111 -1.376,-0.111 -1.428,0 -3.53,0.383 -5.65,2.145 l 10e-4,-9.417 v -3.808 c 0,-1.081 -0.873,-1.96 -1.945,-1.96 -1.073,0 -1.946,0.879 -1.946,1.96 v 0.21 l 0.001,21.84 v 0.563 l 0.417,-0.377 c 0.041,-0.038 4.157,-3.752 6.241,-5.546 1.095,-0.942 2.197,-1.787 3.646,-1.787 0.235,0 0.477,0.02 0.718,0.059 1.981,0.319 3.299,1.347 3.919,3.054 0.72,1.984 0.258,3.834 -1.385,5.512 -3.286,3.355 -6.684,6.825 -10.095,10.164 -1.849,1.81 -3.879,2.848 -6.037,3.085 -2.654,-1.709 -5.751,-2.615 -8.991,-2.62 -3.223,0 -6.329,0.903 -8.989,2.613 -2.019,-0.248 -3.845,-1.145 -5.427,-2.667 -3.221,-3.098 -6.558,-6.424 -9.919,-9.884 l -0.177,-0.183 -0.179,0.181 c -0.869,0.874 -1.739,1.747 -2.62,2.61 -1.096,1.073 -2.249,1.667 -3.521,1.815 -1.599,-1.021 -3.461,-1.563 -5.408,-1.566 -1.937,0 -3.804,0.54 -5.406,1.561 -1.173,-0.152 -2.235,-0.678 -3.157,-1.565 -2.338,-2.249 -4.604,-4.514 -6.735,-6.729 -0.953,-0.993 -0.878,-2.647 0.168,-3.689 0.607,-0.604 1.303,-0.923 2.013,-0.923 0.621,0 1.226,0.251 1.751,0.726 0.557,0.505 1.474,1.38 2.284,2.153 1.049,1 1.7,1.621 1.878,1.756 l 0.402,0.307 V 8.977 c 0,-3.471 -0.019,-14.279 -0.019,-14.293 -0.049,-0.826 -0.728,-1.472 -1.547,-1.472 -0.818,0 -1.497,0.646 -1.546,1.486 0,0 -0.012,5.415 -0.014,7.872 -1.044,-0.869 -2.27,-1.326 -3.56,-1.326 -1.501,0 -2.971,0.64 -4.139,1.803 -2.201,2.193 -2.299,5.737 -0.217,7.903 2.216,2.305 4.573,4.661 7.006,7.001 0.818,0.787 1.738,1.397 2.737,1.819 -1.404,1.805 -2.148,3.994 -2.154,6.353 -0.015,5.651 4.613,10.265 10.353,10.286 2.658,0 5.187,-1.062 7.12,-2.992 1.966,-1.961 3.046,-4.541 3.041,-7.265 -0.004,-2.324 -0.764,-4.569 -2.147,-6.361 1.093,-0.453 2.127,-1.147 3.077,-2.067 2.632,2.679 5.378,5.395 8.165,8.075 1.316,1.266 2.801,2.238 4.419,2.893 -2.257,2.833 -3.452,6.289 -3.462,10.017 -0.023,8.777 7.166,15.945 16.027,15.977 h 0.056 c 4.128,0 8.055,-1.65 11.057,-4.647 3.053,-3.047 4.732,-7.055 4.725,-11.285 -0.006,-3.73 -1.198,-7.19 -3.45,-10.03 1.786,-0.71 3.473,-1.835 5.018,-3.347 3.33,-3.261 6.628,-6.628 9.816,-9.884 C 7.547,12.728 8.383,9.165 7.132,5.719 5.995,2.59 3.463,0.559 0,0 m -33.759,11.261 c 0,-2.514 -0.017,-22.614 -0.02,-22.659 -0.105,-1.142 -1.04,-2.003 -2.174,-2.003 -1.134,0 -2.069,0.861 -2.177,2.048 0,0 -0.014,10.58 -0.017,13.965 -1.522,-1.834 -3.497,-3.001 -5.473,-3.001 -1.712,0 -3.388,0.52 -4.9,1.513 -0.004,-2.212 -0.018,-6.431 -0.019,-6.455 -0.056,-0.957 -0.845,-1.707 -1.795,-1.707 -0.951,0 -1.739,0.75 -1.797,1.736 0,0 -0.015,10.707 -0.015,14.038 v 1.218 l 0.856,-0.867 c 0,0 3.115,-3.153 3.6,-3.636 0.997,-0.992 2.139,-1.517 3.303,-1.517 0.999,0 1.992,0.413 2.871,1.195 1.211,1.076 3.63,3.349 6.814,6.4 l 0.097,0.093 0.846,0.81 z m 21.458,48.311 c -22.922,12.637 -51.749,4.3 -64.386,-18.621 -12.638,-22.922 -4.301,-51.749 18.621,-64.386 22.922,-12.638 51.748,-4.301 64.386,18.621 12.637,22.922 4.3,51.748 -18.621,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParents);
export default __webpack_public_path__ + "static/media/parents.59f1e5b4e97c8c360e711e92a1bee2d0.svg";
export { ForwardRef as ReactComponent };